import { Component, OnDestroy, OnInit, ElementRef  } from '@angular/core';
import { AmvaraVideoComponent } from '../amvara-video/amvara-video.component';
// import { NgDialogAnimationService } from "ng-dialog-animation"; // Deprecated Angular 20.3.13
import { MatDialog } from '@angular/material/dialog'; // Angular new Material Dialog 
import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import { LanguageService } from '../../i18n/language.service';

@Component({
  selector: 'app-about',
  standalone: false,
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.sass'],
})
export class AboutComponent implements OnInit, OnDestroy { 
  mobileOrDesktop: boolean = false;
  amvaraVideosClick: boolean = false;
  private mobileQueryListener: () => void;
  private mobileQuery: MediaQueryList;
  rotationAngle = 0;
  slideLeft: boolean = false;
  private readonly onResize = () => this.setArrowContainerHeight();

  constructor(private dialog: MatDialog, private breakpointObserver: BreakpointObserver, private mediaMatcher: MediaMatcher, private elementRef: ElementRef, public language: LanguageService
  ) {
    // Tiene media:, matches:(true/false) etc 
    this.mobileQuery = this.mediaMatcher.matchMedia('(max-width: 600px)');

    this.mobileQueryListener = () => {
      if (this.mobileQuery.matches) {
        // Reinicia la página si cambias a vista móvil
        location.reload();
      } else {
        // Reinicia la página si cambias a vista de escritorio
        location.reload();
      }
    };
    // Contacta con el css para hacer 
    this.mobileQuery.addEventListener('change', this.mobileQueryListener);
    this.mobileOrDesktop = this.mobileQuery.matches;
  }

  // Go to..  scroll
  onPanelOpened(): void {
    setTimeout(() => {
      this.scrollToElement('goToPos');
    }, 200);
  }
  
  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if(this.amvaraVideosClick && element){
      const yOffset = -60;
      const y = element.getBoundingClientRect().top + scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  openDialog(event: MouseEvent): void {
    // If dispositive is movile(handset)
    if(this.breakpointObserver.isMatched(Breakpoints.Handset)){
      // Rotate the image of amvaras videos link
      if (this.rotationAngle == 0) {
        this.rotationAngle += 90;
      } else {
        this.rotationAngle = 0;
      }
      this.amvaraVideosClick = !this.amvaraVideosClick;
    }
    else{
      // If dispositive is desktop
      this.slideLeft = true;
      const dialogRef = this.dialog.open(AmvaraVideoComponent, {
        height: '100vh',
        width: '60vw',
        position: {
          right: '0',
          top: '0'
        },
        panelClass: 'backdrop',
        // Note: MatDialog uses different animation configuration
        // You may need to configure animations via Angular Animations API
      });
    
      dialogRef.afterClosed().subscribe(result => {
        setTimeout(() => {
          this.slideLeft = false;
        }, 300);
      });
    }
  }

  ngOnInit(): void {
    this.setArrowContainerHeight();
    window.addEventListener("resize", this.onResize);
  }

  setArrowContainerHeight(): void {
    const arrowContainer = document.querySelector(
      ".about__content__row__container__mobile"
    ) as HTMLElement | null;
    const textElement = document.querySelector(
      ".about__content__row__text__mobile"
    );
    // Mobile block is display:none on desktop — getClientRects() can be empty.
    if (!arrowContainer || !textElement) {
      return;
    }
    const rect = textElement.getClientRects()[0];
    if (!rect) {
      return;
    }
    arrowContainer.style.height = rect.height + "px";
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
    window.removeEventListener("resize", this.onResize);
  }

}